import React from 'react';

const GEM_URL = '/gem.png';

/**
 * Animated app-wide gem icon (in-app currency).
 * Subtle bobbing/glow animation. Drop-in replacement for the lucide Diamond icon.
 */
export function GemIcon({ size = 16, className = '', animated = true, style = {} }) {
  return (
    <img
      src={GEM_URL}
      alt="gem"
      width={size}
      height={size}
      className={`inline-block ${animated ? 'gem-anim' : ''} ${className}`}
      style={{
        filter: 'drop-shadow(0 0 6px rgba(225,29,72,0.55))',
        ...style,
      }}
      data-testid="gem-icon"
    />
  );
}

export default GemIcon;
